export default function ({ store, redirect }) {
  // If user is already authenticated, redirect to home
  if (store.getters['auth/isLoggedIn']) {
    return redirect('/')
  }
}

